import React from 'react';
import Seo from '../common/Seo';

const Datenschutz = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Seo title="Datenschutz | SportyReplay" path="/datenschutz" />

      <h1 className="text-3xl font-bold text-gray-900 mb-6">Datenschutzerklärung</h1>
      
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Datenschutz auf einen Blick</h2>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Allgemeine Hinweise</h3>
        <p className="mb-4">
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
          wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
          werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text 
          aufgeführten Datenschutzerklärung.
        </p>

        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Datenerfassung auf unserer Website</h3>
        <p className="mb-4">
          <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
        </p>
        <p className="mb-4">
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
          können Sie dem Impressum dieser Website entnehmen.
        </p>
        
        <p className="mb-4">
          <strong>Wie erfassen wir Ihre Daten?</strong>
        </p>
        <p className="mb-4">
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, 
          die Sie in ein Kontaktformular eingeben.
        </p>
        <p className="mb-4">
          Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische 
          Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, 
          sobald Sie unsere Website betreten.
        </p>
        
        <p className="mb-4">
          <strong>Wofür nutzen wir Ihre Daten?</strong>
        </p>
        <p className="mb-4">
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können 
          zur Analyse Ihres Nutzerverhaltens verwendet werden.
        </p>
        
        <p className="mb-4">
          <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
        </p>
        <p className="mb-4">
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten 
          personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten 
          zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum 
          angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8">2. Allgemeine Hinweise und Pflichtinformationen</h2>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Datenschutz</h3>
        <p className="mb-4">
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten 
          vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>
        <p className="mb-4">
          Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit 
          denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und 
          wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
        </p>
        <p className="mb-4">
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen 
          kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
        <p className="mb-4">
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p className="mb-4">
          Luan Mezini<br />
          E-Mail: info@sportyreplay.de
        </p>
        <p className="mb-4">
          Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und 
          Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
        <p className="mb-4">
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte 
          Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum 
          Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
        <p className="mb-4">
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem 
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht 
          besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Recht auf Datenübertragbarkeit</h3>
        <p className="mb-4">
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, 
          an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung 
          der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">SSL- bzw. TLS-Verschlüsselung</h3>
        <p className="mb-4">
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder 
          Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen 
          Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </p>
        <p className="mb-4">
          Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Auskunft, Sperrung, Löschung und Berichtigung</h3>
        <p className="mb-4">
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten 
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, 
          Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit 
          unter der im Impressum angegebenen Adresse an uns wenden.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Recht auf Einschränkung der Verarbeitung</h3>
        <p className="mb-4">
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit 
          unter der im Impressum angegebenen Adresse an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li className="mb-2">
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um 
            dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen 
            Daten zu verlangen.
          </li>
          <li className="mb-2">
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die 
            Einschränkung der Datenverarbeitung verlangen.
          </li>
          <li className="mb-2">
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von 
            Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen 
            Daten zu verlangen.
          </li>
          <li className="mb-2">
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen 
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der 
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </li>
        </ul>
        <p className="mb-4">
          Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung 
          abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz 
          der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der 
          Europäischen Union oder eines Mitgliedstaats verarbeitet werden.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8">3. Datenerfassung auf unserer Website</h2>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Cookies und lokaler Speicher</h3>
        <p className="mb-4">
          SportyReplay verwendet ausschließlich technisch notwendige Cookies sowie lokalen Browser-Speicher (localStorage).
          Wir setzen keine Tracking-, Werbe- oder Analyse-Cookies ein.
        </p>

        <div className="overflow-x-auto mb-4">
          <table className="w-full text-sm border-collapse border border-gray-200 rounded">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-4 py-2 text-left font-semibold">Name</th>
                <th className="border border-gray-200 px-4 py-2 text-left font-semibold">Typ</th>
                <th className="border border-gray-200 px-4 py-2 text-left font-semibold">Zweck</th>
                <th className="border border-gray-200 px-4 py-2 text-left font-semibold">Speicherdauer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-4 py-2 font-mono text-xs">PHPSESSID</td>
                <td className="border border-gray-200 px-4 py-2">Session-Cookie</td>
                <td className="border border-gray-200 px-4 py-2">Login-Session, Authentifizierung</td>
                <td className="border border-gray-200 px-4 py-2">Browser-Session (wird beim Schließen gelöscht)</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-200 px-4 py-2 font-mono text-xs">user (localStorage)</td>
                <td className="border border-gray-200 px-4 py-2">Lokaler Speicher</td>
                <td className="border border-gray-200 px-4 py-2">Speichert eingeloggte Nutzerdaten (Name, E-Mail, Verein) für wiederholte Seitenaufrufe</td>
                <td className="border border-gray-200 px-4 py-2">Bis zum Abmelden oder manuellem Löschen</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-4 py-2 font-mono text-xs">cookieConsent (localStorage)</td>
                <td className="border border-gray-200 px-4 py-2">Lokaler Speicher</td>
                <td className="border border-gray-200 px-4 py-2">Speichert Ihre Cookie-Einwilligung</td>
                <td className="border border-gray-200 px-4 py-2">1 Jahr (oder bis zum manuellen Zurücksetzen)</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-200 px-4 py-2 font-mono text-xs">lastActivity (localStorage)</td>
                <td className="border border-gray-200 px-4 py-2">Lokaler Speicher</td>
                <td className="border border-gray-200 px-4 py-2">Session-Timeout-Erkennung (Sicherheit)</td>
                <td className="border border-gray-200 px-4 py-2">Bis zum Abmelden</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="mb-4">
          Sie können Ihre Cookie-Einstellungen jederzeit über den Link "Cookie-Einstellungen" im Footer dieser Website anpassen.
          Die Rechtsgrundlage für technisch notwendige Cookies ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
          technisch fehlerfreien Bereitstellung des Dienstes).
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Server-Log-Dateien</h3>
        <p className="mb-4">
          Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser 
          automatisch an uns übermittelt. Dies sind:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Uhrzeit der Serveranfrage</li>
          <li>IP-Adresse</li>
        </ul>
        <p className="mb-4">
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
        </p>
        <p className="mb-4">
          Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes 
          Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files 
          erfasst werden.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">Registrierung auf dieser Website</h3>
        <p className="mb-4">
          Sie können sich auf unserer Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. Die dazu eingegebenen Daten 
          verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, für den Sie sich registriert haben. Die bei der 
          Registrierung abgefragten Pflichtangaben müssen vollständig angegeben werden. Anderenfalls werden wir die Registrierung ablehnen.
        </p>
        <p className="mb-4">
          Für wichtige Änderungen etwa beim Angebotsumfang oder bei technisch notwendigen Änderungen nutzen wir die bei der Registrierung 
          angegebene E-Mail-Adresse, um Sie auf diesem Wege zu informieren.
        </p>
        <p className="mb-4">
          Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). 
          Sie können eine von Ihnen erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. 
          Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>
        <p className="mb-4">
          Die bei der Registrierung erfassten Daten werden von uns gespeichert, solange Sie auf unserer Website registriert sind und werden 
          anschließend gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8">4. Analyse-Tools und Werbung</h2>
        <p className="mb-4">
          Wir verwenden derzeit keine Analyse-Tools oder Werbedienste von Drittanbietern auf unserer Website.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8">5. Plugins und Tools</h2>
        <p className="mb-4">
          Wir verwenden derzeit keine externen Plugins oder Tools auf unserer Website.
        </p>
      </div>
    </div>
  );
};

export default Datenschutz;